import { EnvironmentProviders, ErrorHandler, makeEnvironmentProviders } from '@angular/core';
import { AppErrorHandler } from './error-handler';

/**
 * Handles unhandled errors: network and chunk load errors are shown to the
 * user, other errors are reported to Sentry (see `initSentry`).
 */
export function provideErrorHandling(): EnvironmentProviders {
  return makeEnvironmentProviders([{ provide: ErrorHandler, useClass: AppErrorHandler }]);
}
